export const defaultTheme = {
  white: '#FFFFFF',

  'login-bg': '#F0F0F5',
  'page-bg': '#F8F8F9',
  'header-bg': '#1A4D3A', // Updated to match new navigation color
  'header-bg-old': '#0E8750', // Keep old color for backward compatibility

  'green-50': '#EEF7F7',
  'green-100': '#EEF6F6',
  'green-200': '#ACD9C5',
  'green-300': '#00B37E',
  'green-500': '#00875F',
  'green-600': '#43A047',
  'green-700': '#015F43',

  'gray-50': '#EFF0F6',
  'gray-100': '#E1E1E6',
  'gray-200': '#D0D5DD',
  'gray-300': '#C4C4CC',
  'gray-400': '#8D8D99',
  'gray-500': '#7C7C8A',
  'gray-600': '#3F3F55',
  'gray-700': '#29292E',
  'gray-800': '#202024',
  'gray-900': '#121214',

  'red-300': '#F75A68',
  'red-500': '#AB222E',
  'red-600': '#971D1D',
  'red-700': '#7A1921',

  'blue-300': '#2196F3',
  'blue-600': '#1976D2',
  indigo: '#6610f2',
  purple: '#6f42c1',
  pink: '#e83e8c',
  red: '#dc3545',
  'orange-100': '#ffd2ad',
  orange: '#fd7e14',
  yellow: '#ffc107',
  'yellow-500': '#FFEB3B',
  'yellow-800': '#F9A825',
  green: '#28a745',
  teal: '#20c997',
  cyan: '#1FA7AF',
  'gray-dark': '#3F4254',

  light: '#f5f8fa',
  primary: '#3699FF',
  'primary-hover': '#187DE4',
  secondary: '#E4E6EF',
  success: '#1BC5BD',
  info: '#7239ea',
  warning: '#ffc700',
  danger: '#f1416c',
  dark: '#181C32',

  'primary-light': '#f1faff',
  'secondary-light': '#f5f8fa',
  'success-light': '#e8fff3',
  'info-light': '#f8f5ff',
  'warning-light': '#fff8dd',
  'danger-light': '#fff5f8',
  'dark-light': '#eff2f5',

  'sidebar-bg': '#1e1e2d',
  'sidebar-active': '#2a2a3c',

  'sidebar-text-item': '#9d9da6',
  'sidebar-text-hover': '#FFFFFF',
  'sidebar-text-active': '#FFFFFF',

  gray: {
    0: '#FFFFFF',
    50: '#F8FAFC',
    100: '#F1F5F9',
    200: '#E2E8F0',
    300: '#CBD5E1',
    400: '#94A3B8',
    500: '#64748B',
    600: '#475569',
    700: '#334155',
    800: '#1E293B',
    900: '#0F172A',
  },

  blue: {
    50: '#EFF6FF',
    100: '#DBEAFE',
    300: '#93C5FD',
    500: '#3B82F6',
    600: '#2563EB',
    700: '#1D4ED8',
  },

  greenScale: {
    50: '#ECFDF5',
    100: '#D1FAE5',
    300: '#6EE7B7',
    500: '#2D6A4F',
    600: '#1A4D3A',
    700: '#1B4332',
  },
} as const;
